"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (_a) {
    var authKey = (_a === void 0 ? {} : _a).authKey;
    return ({
        action: 'gatewayLogin',
        msgId: virtual.msgId,
        params: {
            authKey: authKey,
            devTid: virtual.device.devTid,
            prodKey: virtual.device.prodKey
        }
    });
}; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/gatewayLogin.ts